import { apiCall } from '../../services/apiUtil';

export const marketplaceAPI = {
  // Listings
  getListings: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.categoryId) params.append('categoryId', filters.categoryId);
    if (filters.minPrice) params.append('minPrice', filters.minPrice);
    if (filters.maxPrice) params.append('maxPrice', filters.maxPrice);
    if (filters.condition) params.append('condition', filters.condition);
    if (filters.status) params.append('status', filters.status);
    if (filters.search) params.append('search', filters.search);
    if (filters.sortBy) params.append('sortBy', filters.sortBy);
    if (filters.page) params.append('page', filters.page);
    if (filters.limit) params.append('limit', filters.limit);

    const queryString = params.toString();
    const endpoint = queryString
      ? `/marketplace/listings?${queryString}`
      : '/marketplace/listings';

    return apiCall(endpoint);
  },

  // Semantic + location search
  searchListings: async (searchParams = {}) => {
    const params = new URLSearchParams();
    if (searchParams.query) params.append('query', searchParams.query);
    if (searchParams.userLat != null) params.append('userLat', searchParams.userLat);
    if (searchParams.userLng != null) params.append('userLng', searchParams.userLng);
    if (searchParams.radiusKm != null) params.append('radiusKm', searchParams.radiusKm);
    if (searchParams.categoryId) params.append('categoryId', searchParams.categoryId);
    if (searchParams.minPrice) params.append('minPrice', searchParams.minPrice);
    if (searchParams.maxPrice) params.append('maxPrice', searchParams.maxPrice);
    if (searchParams.condition) params.append('condition', searchParams.condition);
    if (searchParams.sortBy) params.append('sortBy', searchParams.sortBy);
    if (searchParams.page) params.append('page', searchParams.page);
    if (searchParams.limit) params.append('limit', searchParams.limit);

    const queryString = params.toString();
    const endpoint = queryString
      ? `/marketplace/search?${queryString}`
      : '/marketplace/search';

    return apiCall(endpoint);
  },

  getListingById: async (id) => {
    return apiCall(`/marketplace/listings/${id}`);
  },

  createListing: async (listingData) => {
    return apiCall('/marketplace/listings', {
      method: 'POST',
      body: JSON.stringify(listingData),
    });
  },

  updateListing: async (id, listingData) => {
    return apiCall(`/marketplace/listings/${id}`, {
      method: 'PUT',
      body: JSON.stringify(listingData),
    });
  },

  deleteListing: async (id) => {
    return apiCall(`/marketplace/listings/${id}`, {
      method: 'DELETE',
    });
  },

  markAsSold: async (id, buyerId = null) => {
    return apiCall(`/marketplace/listings/${id}/sold`, {
      method: 'PATCH',
      body: JSON.stringify({ buyerId }),
    });
  },

  getMyListings: async (status = null) => {
    const params = new URLSearchParams();
    if (status) params.append('status', status);
    const queryString = params.toString();
    const endpoint = queryString
      ? `/marketplace/my-listings?${queryString}`
      : '/marketplace/my-listings';
    return apiCall(endpoint);
  },

  // Categories
  getCategories: async () => {
    return apiCall('/marketplace/categories');
  },

  // Saved Listings
  getSavedListings: async () => {
    return apiCall('/marketplace/saved');
  },

  saveListing: async (listingId) => {
    return apiCall(`/marketplace/saved/${listingId}`, {
      method: 'POST',
    });
  },

  unsaveListing: async (listingId) => {
    return apiCall(`/marketplace/saved/${listingId}`, {
      method: 'DELETE',
    });
  },

  checkIfSaved: async (listingId) => {
    return apiCall(`/marketplace/saved/${listingId}/check`);
  },
};

export default marketplaceAPI;
